import * as yup from 'yup'

export const schema = yup.object().shape({
  code: yup
    .array()
    .of(yup.string().required('Code is required').min(1, 'Code cannot be empty'))
    .required('Code is required')
    .min(5, 'There must be exactly 5 items in the code array')
    .max(5, 'There must be exactly 5 items in the code array'),
  rememberDevice: yup.boolean(),
})
